import styles from "./index.module.css";

export type Props = {
  message: string;
};

export const TalkGuide = ({ message }: Props) => {
  return (
    <div className={styles.guideBox}>
      <div className={styles.guideMessage}>{message}</div>
    </div>
  );
};
